
import React from "react";
import OurStoreDetails from "./pages-components/about-us-components/our-store-details";
function OurStore (){
    return(
        <>
        <br/>
        <br/>
        <br/>
        <br/>
        {/* <!-- page-title --> */}
        <div class="tf-page-title style-2">
            <div class="container-full">
                <div class="heading text-center">Our Store</div>
            </div>
        </div>
        {/* <!-- /page-title --> */}
        <OurStoreDetails/>
        <br/>
        <br/>
        </>
    )
}
export default OurStore;